export const ProjectName: string = "VCurrent";
export const MinPasswordLength: number = 6;
